import {
  getNews,
  getNewsSuccess,
  getNewsTypesSuccess,
  reactOnNewsSuccess
} from './news.actions';
import { createReducer, on } from '@ngrx/store';
import { initialNewsState } from './news.state';
import { cloneDeep } from '@apollo/client/utilities';

export const reducer = createReducer(
  initialNewsState,

  on(getNews, (state) => ({
    ...state,
    loading: true
  })),
  on(getNewsSuccess, (state, { news }) => ({
    ...state,
    news: news,
    loading: false
  })),
  on(getNewsTypesSuccess, (state, { newsTypes }) => ({
    ...state,
    newsTypes: newsTypes,
    loading: false
  })),

  on(reactOnNewsSuccess, (state, { newsItem }) => {
    const news = cloneDeep(state.news);
    const data = news.find((item) => item.id === newsItem.id);

    if (data) {
      data.reaction = newsItem.reaction;
    }

    news.forEach((n) => {
      if (n.id === newsItem.id) {
        n.reaction = newsItem.reaction;
      }
    });

    return {
      ...state,
      news: [...news]
    };
  })
);
